import { decrypt } from "./encryption";

export const getSession = function getUserSessionFromCookie() {
  const session = document.cookie
    .split("; ")
    .find((row) => row.startsWith("user_session="))
    ?.split("=")[1];

  return JSON.parse(session ?? null);
};

export const getSessionToken = function getDecryptedSessionToken() {
  const encryptedtoken = getSession()?.token;
  return encryptedtoken ? decrypt(encryptedtoken) : null;
};
